import { Text, Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import styles from './DatasourceWithChildrenContentResolver.module.scss';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';

type DatasourceWithChildrenContentResolverProps = ComponentProps & {
  fields: {
    title: Field<string>;
    body: Field<string>;
    children: Item[];
  };
};

/**
 * A component that uses the custom Datasource with Children Content Resolver.
 */
const DatasourceWithChildrenContentResolver = ({
  fields,
}: DatasourceWithChildrenContentResolverProps): React.JSX.Element => {
  return (
    <div className={styles.datasourceWithChildrenContentResolver}>
      <Text tag="h2" className="contentTitle" field={fields.title} />
      <RichTextWrapper className="contentDescription" field={fields.body} />

      <section>
        <h5>Children Sitecore Items</h5>
        <p>Rendering the Sub Item Title from children Items of the Datasource.</p>
      </section>
      <ul>
        {fields.children?.map((item, i) => (
          <li key={i}>
            <Text field={item.fields.subItemTitle as Field<string>} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default withValidDatasourceCheck()<DatasourceWithChildrenContentResolverProps>(
  DatasourceWithChildrenContentResolver
);
